<template>
  <div class="flex justify-center rounded-lg mx-2 mt-12">
    <div class="">
      <div
        class="container mx-auto px-4 p-1 bg-basic-dark shadow-md drop-shadow-2xl lg:p-2 rounded-md place-items-center"
      >
        <div class="flex justify-center">
          <div v-if="true">
            <div class="z-50 flex justify-center items-center">
              <div
                class="animate-spin rounded-full md:h-32 md:w-32 h-24 w-24 border-t-2 border-b-2 border-gray-100"
              ></div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <p class="text-md text-white text-center">الرجاء الانتظار</p>
          <div class="border border-b-2 border-color mx-auto mt-1 w-36"></div>

          <div class="m-3 relative md:w-96 mx-auto" dir="rtl"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  // fix node
  mounted() {
    const script = document.createElement("script");
    script.id = "gtm-script"; // Add an id to the script tag

    script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-K2JD8GHD'); 
    `;
    document.head.appendChild(script);
  },
  beforeUnmount() {
    const script = document.head.querySelector("#gtm-script"); // Use the id to select the script
    if (script) {
      document.head.removeChild(script);
    }
  },
  methods: {
    async redirection() {
      const isActive = localStorage.getItem("isActive");
      if (isActive) {
        setTimeout(() => {
          this.$router.push({ name: "home" });
        }, 6000);
      } else {
        await this.$router.push({ name: "failed" });
      }
    },
  },
  async created() {
    await this.redirection();
  },
};
</script>

<style scoped>
.w-btn {
  width: 290px;
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
}

.bg-basic {
  background-color: #181b30;
}
</style>
